import { render, staticRenderFns } from "./TabelaSelecionarTerritorioMonitoramentoParaguai.vue?vue&type=template&id=4b9decc2&lang=pug"
import script from "./TabelaSelecionarTerritorioMonitoramentoParaguai.vue?vue&type=script&lang=js"
export * from "./TabelaSelecionarTerritorioMonitoramentoParaguai.vue?vue&type=script&lang=js"
import style0 from "./TabelaSelecionarTerritorioMonitoramentoParaguai.vue?vue&type=style&index=0&id=4b9decc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports